import React, { useState, useEffect, useMemo } from "react";
import {
  APMCsByDistrict,
  ItemsSponsor,
} from "../../../../../core/data/json/contractFarming";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  apmcByDistrictId,
  getAllSpices,
  SponsorRegistration,
  submitContractFarmingFiles,
  approveRejectContactFarming
} from "../../../../auth/services/privateapicalling";
import { getAllAPMC } from "../../../../auth/services/apiCalling";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import DocView from "./DocView";
import { color } from "html2canvas/dist/types/css/types/color";
// import SingleView from "../../../../pages/pdfloader/Singleview";

interface MBAFormProps {
  applicationId: any;
  applicationDataInfo: any;
  valCalledIn: any;
}

const MBAFormJ = ({ applicationId, applicationDataInfo, valCalledIn }: MBAFormProps) => {
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;


  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    fromDate: "",
    toDate: "",
    years: "",
    solvencyCertificate: null as any,
    bankGuarantee: null as any,
    firmNgoCoopCoopDetails: null as any,
    agriculturalProduceDetails: "",
    challanCopy: null as any,
    licenseProof: null as any,
    e_Hastakshar: null as any,
  });
  const [resubmit, setResubmit] = useState<any>({});  
 
  
  const [isDisabled, setIsDisabled] = useState((true && roleIdentifier==="MBA") || valCalledIn==="registrationStatus" ? true : false);
  const [districtOptions, setDistrictOptions] = useState<any[]>([]);
  const [spicesOptions, setSpicesOptions] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState<any[]>([]);
  const [selectedAPMCs, setSelectedAPMCs] = useState([]);
  const [selectedIngredients, setSelectedIngredients] = useState<any[]>([]);
  const [apmcData, setApmcData] = useState([]);
  const [commodityData, setCommodityData] = useState([]);
  const [documentUpdateTrigger, setDocumentUpdateTrigger] = useState(0);
  const [forwardSuccess, setForwardSuccess] = useState(false)
  const [organizationType, setOrganizationType] = useState("");
  const organizationTypeOptions = [
  { value: "Company", label: "Company" },
  { value: "Partnership Firm", label: "Partnership Firm" },
  { value: "Non-Governmental Organization", label: "Non-Governmental Organization" },
  { value: "Co-operative Society", label: "Co-operative Society" },
  { value: "Government Organization", label: "Government Organization" }
];
  const [fruitsSelection, setFruitsSelection] = useState<{
    [key: string]: boolean;
  }>({});
  const [otherInputs, setOtherInputs] = useState({});
  const [selectedOthersCount, setSelectedOthersCount] = useState(0);
  const [selectedDocId, setSelectedDocId] = React.useState<string | null>(null);
  const [statusLevel, setStatusLevel] = useState("")
  
  const [comment, setComment] = useState("");
  const [changedFields, setChangedFields] = useState<any>({});
  const [hasChanges, setHasChanges] = useState(false);
  const [newlyUploaded, setNewlyUploaded] = useState<{[key: string]: string}>({});
  const [uploadLoading, setUploadLoading]=useState(false);
  const navigate = useNavigate();

  // Calculate fees
  const anyFruitsSelected = Object.values(fruitsSelection).some(Boolean);
  const fruitsFee = anyFruitsSelected ? 500 : 0;
  const othersFee = selectedOthersCount * 500;
  const totalFee = fruitsFee + othersFee;
  const showFeeSummary = anyFruitsSelected || selectedOthersCount > 0;

 
  // Populate form data
  const populateFormData = (apiData: any) => {
    if (!apiData) return;

    const baseData = {
      name: apiData?.Sponsor_Name || "",
      address: apiData?.Sponsor_Address || "",
      phone: apiData?.Sponsor_Phone || "",
      fromDate: apiData?.Sponsor_Reg_From || "",
      toDate: apiData?.Sponsor_Reg_To || "",
      years: apiData?.Sponsor_Reg_Year || "",
    };

    // Populate uploaded documents
    if (apiData.uploadedDoc) {
      const docs = apiData.uploadedDoc;
      const docFields = {
        solvencyCertificate: docs.solvencyCertificate?.data || null,
        bankGuarantee: docs.bankGuarantee?.data || null,
        firmNgoCoopCoopDetails: docs.firmNgoCoopCoopDetails?.data || null,
        challanCopy: docs.challanCopy?.data || null,
        licenseProof: docs.licenseProof?.data || null,
        e_Hastakshar: docs.e_Hastakshar?.data || null,
      };

      setFormData((prev) => ({
        ...prev,
        ...baseData,
        ...docFields,
      }));

      if (docs.firmNgoCoopCoopDetails?.data?.documentName) {
        const docName = docs.firmNgoCoopCoopDetails.data.documentName;
        
        // Check if it's a valid organization type
        const isValidOrgType = organizationTypeOptions.some(opt => opt.value === docName);
        
        if (isValidOrgType) {
          setOrganizationType(docName);
        } else if (docName !== "firmNgoCoopCoopDetails") {
          // It might be a custom value
          setOrganizationType(docName);
        }
      }
      
      // Initialize resubmit with empty object to avoid undefined issues
      setResubmit({});
      } else {
        setFormData((prev) => ({
          ...prev,
          ...baseData,
        }));
      }
    
    // Populate commodity data
    if (apiData.commodityRegsBySponsorRegNo?.length > 0) {
      const commodities = apiData.commodityRegsBySponsorRegNo;

      // Set selected districts
      const uniqueDistricts = Array.from(
        new Set(commodities.map((c) => c.district_id))
      );
      const districtData = uniqueDistricts.map((distId) => {
        const commodity = commodities.find((c) => c.district_id === distId);
        return {
          value: distId,
          label: commodity?.departmentDetailsByApmc?.District || "",
        };
      });
      setSelectedDistricts(districtData);
     

      // Fetch APMCs for selected districts
      const districtIds = districtData.map((d) => d.value);
      if (districtIds.length > 0) {
        fetchApmcId(districtIds);
      }

      // Set selected APMCs
      setTimeout(() => {
        const apmcDataToSet = commodities.map((c) => ({
          value: c.apmcId,
          label: c.departmentDetailsByApmc?.apmcName || "",
          other: c.departmentDetailsByApmc,
        }));
        setSelectedAPMCs(apmcDataToSet);
      }, 500);

      // Set fruits selection
      const fruitsSelectionData = {};
      commodities.forEach((c) => {
        if (c.fruitsAndVeg) {
          fruitsSelectionData[c.apmcId] = true;
        }
      });
      setFruitsSelection(fruitsSelectionData);

      // Set others/spices selection
      const othersData = {};
      let othersCount = 0;
      commodities.forEach((c) => {
        if (c.Others && c.Others_Name?.length > 0) {
          othersData[c.apmcId] = c.Others_Name.map((name) => ({
            label: name,
            value: name,
          }));
          othersCount++;
        }
      });
      setOtherInputs(othersData);
      setSelectedOthersCount(othersCount);

      // Set commodity data
      setCommodityData(
        commodities.map((c) => ({
          apmcId: c.apmcId,
          district_id: c.district_id,
          fruitsAndVeg: c.fruitsAndVeg,
          Others: c.Others,
          Others_Name: c.Others_Name || [],
        }))
      );
    }

    // Set selected ingredients
    if (apiData?.Det_Agriculture_Prod) {
      const ingredients = apiData.Det_Agriculture_Prod.split(", ").map(
        (item) => ({
          label: item,
          value: item,
        })
      );
      setSelectedIngredients(ingredients);
    }
  };

  const validateForm = () => {
  const errors: string[] = [];
  
  // Get the current values (either from resubmit or formData)
  const currentName = resubmit?.Sponsor_Name ?? formData?.name;
  const currentAddress = resubmit?.Sponsor_Address ?? formData?.address;
  const currentPhone = resubmit?.Sponsor_Phone ?? formData?.phone;
  const currentFromDate = resubmit?.Sponsor_Reg_From ?? formData?.fromDate;
  const currentToDate = resubmit?.Sponsor_Reg_To ?? formData?.toDate;

  
  // Validate text fields
  if (!currentName || currentName.trim() === "") {
    errors.push("Sponsor name is required");
  }
  
  if (!currentAddress || currentAddress.trim() === "") {
    errors.push("Sponsor address is required");
  }
  
  if (!currentPhone || currentPhone.trim() === "") {
    errors.push("Phone number is required");
  } else if (currentPhone.length > 10) {
    errors.push("Phone number must be 10 digits or less");
  }
  
  // Validate dates
  if (!currentFromDate) {
    errors.push("From date is required");
  }
  
  if (!currentToDate) {
    errors.push("To date is required");
  }
  
  // Validate districts
  if (!selectedDistricts || selectedDistricts.length === 0) {
    errors.push("At least one district must be selected");
  }
  
  // Validate APMCs
  if (!selectedAPMCs || selectedAPMCs.length === 0) {
    errors.push("At least one APMC must be selected");
  }
  
  // Validate ingredients
  // if (!selectedIngredients || selectedIngredients.length === 0) {
  //   errors.push("At least one agricultural produce item must be selected");
  // }

  if(!comment){
    errors.push("Comment Required")
  }
  
  // Validate documents (check both resubmit and formData)
  const docs = [
    { field: 'solvencyCertificate', name: 'Solvency certificate' },
    // { field: 'bankGuarantee', name: 'Bank Guarantee' },
    { field: 'firmNgoCoopCoopDetails', name: 'Registration Documents' },
    { field: 'challanCopy', name: 'Challan Copy' },
    { field: 'licenseProof', name: 'License Proof' }
  ];
  
  docs.forEach(doc => {
    const hasResubmit = resubmit?.[doc.field]?.data?.[0]?.docId;
    const hasOriginal = formData?.[doc.field]?.docId;
    
    if (!hasResubmit && !hasOriginal) {
      errors.push(`${doc.name} is required`);
    }
  });
  
  return errors;
  };

  const fetchDistrict = async () => {
    try {
      const response = await getAllAPMC(token, "", "");
      const districts = response.data.map((d) => ({
        label: d.District,
        value: d.district_id,
      }));
      setDistrictOptions(districts);
    } catch (error) {
    
      toast.error("Cannot Access Districts",{position:"top-right"});
    }
  };

  const fetchApmcId = async (data: any) => {
    const payload = {
      districtIds: data,
    };
    try {
      const res = await apmcByDistrictId(payload, token);
      let apmcList = res.data.map((item: any) => ({
        value: item.id,
        label: item.apmcName,
        other: item,
      }));
      setApmcData(apmcList);
    } catch (error) {
   
    }
  };

  useEffect(() => {
    getAllSpices(token)
      .then((data) => {
        const formatted = data.data.map((item) => ({
          value: item.id,
          label: item.Spices,
        }));
        setSpicesOptions(formatted);
      })
      .catch();
  }, []);

  useEffect(() => {
    fetchDistrict();
  }, []);

 useEffect(() => {
  if (applicationDataInfo) {
    populateFormData(applicationDataInfo);
    
    
  }
}, [applicationDataInfo]);

const editHandler = () => {
  if (isDisabled) {
    // User wants to edit - allow editing
    setIsDisabled(false);
    setChangedFields({});
    setHasChanges(false);
    toast.success("You Can Edit the Form", { position: "top-right" });
  } else {
    // User wants to lock - validate before locking
    const errors = validateForm();
    
    if (errors.length > 0) {
      // Show all errors
      errors.forEach(error => {
        toast.error(error, { position: "top-right", autoClose: 3000 });
      });
      return; // Don't lock the form
    }
    
    // If no errors, lock the form
    setIsDisabled(true);
    toast.success("Form locked successfully", { position: "top-right" });
  }
};

const handleInputChange = (field: string, value: string) => {
  setResubmit((prev) => ({
    ...prev,
    [field]: value,
  }));
  setChangedFields((prev) => ({
    ...prev,
    [field]: value,
  }));
  setHasChanges(true);
};

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string
  ) => {
    const { files } = e.target;
    if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      handleUpload(fileName, file, fieldName, formData[fieldName]?.docId);
    }
  };


  
const handleUpload = async (
  documentName: string,
  file: any,
  fieldName: string,
  docId?: string | null
) => {
  const uploadFormData = new FormData();
  uploadFormData.append("file", file);
  uploadFormData.append("documentName", fieldName);
  uploadFormData.append("fieldName", fieldName);
  uploadFormData.append("applicationId", applicationId);

  try {
    setUploadLoading(true)
    const res = await submitContractFarmingFiles(
      uploadFormData,
      token,
      docId
    );

    if (res.success === false) {
      toast.error(res?.message, { position: "top-right" });
    } else if (res.success && res.docId) {
      const data = {
        docId: res.docId,
        documentName: fieldName,
        fileName: documentName,
      };
      
      setResubmit((prev) => ({
        ...prev,
        [fieldName]: {
          type:'document',
          data: [data]
        },
      }));
      
      // Track newly uploaded files
      setNewlyUploaded((prev) => ({
        ...prev,
        [fieldName]: documentName
      }));
      
      // Track document changes
      setChangedFields((prev) => ({
        ...prev,
        [fieldName]: {
          data: {
            docId: res.docId,
            documentName: fieldName,
          }
        },
      }));
      setHasChanges(true);
      
      toast.success(res?.message, { position: "top-right" });
      setDocumentUpdateTrigger(prev => prev + 1);
    }
  } catch (error) {
    toast.error("File upload failed", { position: "top-right" });
  } finally{
      setUploadLoading(false)
  }
};

  const adjustInputWidth = (text: string, minWidth: number = 200) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = "1.25rem Arial";
      const textWidth = context.measureText(text).width;
      return Math.max(minWidth, textWidth + 10);
    }
    return minWidth;
  };

  const handleDistrictChange = (selected: any) => {
  setSelectedDistricts(selected);
  setChangedFields((prev) => ({
    ...prev,
    districts: selected,
  }));
  setHasChanges(true);
};

const handleAPMCChange = (selected: any) => {
  setSelectedAPMCs(selected);
  setChangedFields((prev) => ({
    ...prev,
    apmcs: selected,
  }));
  setHasChanges(true);
};

const handleIngredientsChange = (selected: any) => {
  setSelectedIngredients(selected);
  setChangedFields((prev) => ({
    ...prev,
    Det_Agriculture_Prod: selected.map((item: any) => item.label).join(", "),
  }));
  setHasChanges(true);
};

const handleDateChange = (field: "Sponsor_Reg_From" | "Sponsor_Reg_To", value: string) => {
  // Update only the changed field in resubmit
  let updatedForm = { ...resubmit, [field]: value };
  
  // Get BOTH dates - uses API date (formData) if user hasn't changed it
  const fromDate = field === "Sponsor_Reg_From" 
    ? value  // User just changed this
    : (resubmit?.Sponsor_Reg_From || formData.fromDate || "");  // Use API date if not changed
    
  const toDate = field === "Sponsor_Reg_To" 
    ? value  // User just changed this
    : (resubmit?.Sponsor_Reg_To || formData.toDate || "");  // Use API date if not changed

  // Calculate years if BOTH dates exist
  if (fromDate && toDate) {
    const start = new Date(fromDate);
    const end = new Date(toDate);

    if (end < start) {
      toast.error("End date must be greater than or equal to start date.", { position: "top-right" });
      // Clear the invalid field
      if (field === "Sponsor_Reg_To") {
        updatedForm.Sponsor_Reg_To = "";
      } else {
        updatedForm.Sponsor_Reg_From = "";
      }
      updatedForm.Sponsor_Reg_Year = "";
    } else {
      // Calculate year difference
      let diffYears = end.getFullYear() - start.getFullYear();
      if (
        end.getMonth() < start.getMonth() ||
        (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())
      ) {
        diffYears--;
      }
      updatedForm.Sponsor_Reg_Year = diffYears.toString();
    }
  } else {
    // If only one date exists, clear the year
    updatedForm.Sponsor_Reg_Year = "";
  }

  // Update resubmit with only changed/calculated fields
  setResubmit(updatedForm);
  
  // ✅ FIX: Update changedFields - preserve previous changes, only add new date fields
  setChangedFields((prev) => ({
    ...prev,
    [field]: value,  // Only the date field that changed
    Sponsor_Reg_Year: updatedForm.Sponsor_Reg_Year  // Calculated year
  }));
  
  setHasChanges(true);
};


  
const handleForward = async () => {
  // Validate before forwarding
  const errors = validateForm();
  
  if (errors.length > 0 && roleIdentifier==="MBA") {
    // Show all errors
    errors.forEach(error => {
      toast.error(error, { position: "top-right", autoClose: 3000 });
    });
    return; // Don't proceed with forwarding
  }
  
  try {
    const submittedFields: any = { ...resubmit };
    
    // ✅ FIX: Handle dates - if any date was changed, include BOTH dates
    if (resubmit.Sponsor_Reg_From || resubmit.Sponsor_Reg_To || resubmit.Sponsor_Reg_Year) {
      submittedFields.Sponsor_Reg_From = resubmit.Sponsor_Reg_From || formData.fromDate;
      submittedFields.Sponsor_Reg_To = resubmit.Sponsor_Reg_To || formData.toDate;
    }
    
    // Handle document fields properly
    const docFields = [
      'solvencyCertificate',
      'bankGuarantee',
      'firmNgoCoopCoopDetails',
      'challanCopy',
      'licenseProof',
      'e_Hastakshar'
    ];
    
    docFields.forEach(field => {
      if (resubmit[field]?.data?.[0]?.docId) {
        submittedFields[field] = {
          type: 'document',
          data: resubmit[field].data[0] 
        };
      } 
      else if (formData[field]?.docId) {
        submittedFields[field] = {
          type: 'document',
          data: {
            docId: formData[field].docId,
            documentName: field,
            fileName: formData[field].fileName
          }
        };
      }
    });
    
    const payload = {
      applicationId: applicationId,
      status: applicationDataInfo.buttonName[0].status, 
      appStatusLevel: applicationDataInfo.buttonName[0].appStatusLevel,
      comment: comment,
      submittedFields: submittedFields,
    };
    
    const response = await approveRejectContactFarming(payload, token);
    
    if (response.success) {
      toast.success("Application forwarded successfully", { position: "top-right" });
      setChangedFields({});
      setHasChanges(false);
      setIsDisabled(true);
      setNewlyUploaded({});
      setResubmit({});
      setForwardSuccess(true)
      if(roleIdentifier==="SPO"){
        setTimeout(()=>{
          navigate("/sponsor-reg-menu")
        },1000)
    }else{
       setTimeout(()=>{
          navigate("/marketing-board-reg-menu")
        },1000)
    }
    } else {
      toast.error(response.message || "Failed to forward application", { position: "top-right" });
    }
  } catch (error) {
  
    toast.error("Failed to forward application", { position: "top-right" });
  }
};



const getFieldColorClass = (apiField: string, formDataField: string) => {
  const resubmitValue = resubmit?.[apiField];
  const formValue = formData[formDataField];
  const status = applicationDataInfo?.status;
  
  let pendingFieldMBMD = null;
  let pendingFieldMBA = null;
  
  // For SPO when status is "reject"
  if (roleIdentifier === "SPO" && status === "reject") {
    // Check if resubmission cycle exists
    const hasResubmissionCycle = 
      applicationDataInfo?.transaction?.pendingAtMBMDResubmission || 
      applicationDataInfo?.transaction?.pendingAtMBAResubmission;
    
    if (hasResubmissionCycle) {
      // Use ONLY resubmission fields (second cycle)
      pendingFieldMBMD = applicationDataInfo?.transaction?.pendingAtMBMDResubmission?.reSubmittedFields?.[apiField];
      pendingFieldMBA = applicationDataInfo?.transaction?.pendingAtMBAResubmission?.reSubmittedFields?.[apiField];
    } else {
      // Use ONLY first cycle fields
      pendingFieldMBMD = applicationDataInfo?.transaction?.pendingAtMBMD?.reSubmittedFields?.[apiField];
      pendingFieldMBA = applicationDataInfo?.transaction?.pendingAtMBA?.reSubmittedFields?.[apiField];
    }
  }
  // For MBMD in resubmission cycle
  else if (roleIdentifier === "MBMD" && status === "resubmission") {
    pendingFieldMBA = applicationDataInfo?.transaction?.pendingAtMBAResubmission?.reSubmittedFields?.[apiField];
  }
  // For MBMD in first cycle (pending)
  else if (roleIdentifier === "MBMD" && status === "pending") {
    pendingFieldMBA = applicationDataInfo?.transaction?.pendingAtMBA?.reSubmittedFields?.[apiField];
  }
  // MBA never sees colors
  else if (roleIdentifier === "MBA") {
    return "";
  }
  
  // Green: User just edited this field in current session
  if (resubmitValue && resubmitValue !== formValue) {
    return "text-success";
  } 
  
  // Check MBMD changes first (higher priority) - show in red/danger
  if (pendingFieldMBMD) {
    if (typeof pendingFieldMBMD === 'object' && pendingFieldMBMD !== null) {
      if ('previousValue' in pendingFieldMBMD && 'currentValue' in pendingFieldMBMD) {
        if (pendingFieldMBMD.previousValue !== pendingFieldMBMD.currentValue) {
          return "text-danger"; // Red for MBMD changes
        }
      }
    } else if (pendingFieldMBMD) {
      return "text-danger";
    }
  }
  
  // Check MBA changes (lower priority) - show in yellow
  if (pendingFieldMBA) {
    if (typeof pendingFieldMBA === 'object' && pendingFieldMBA !== null) {
      if ('previousValue' in pendingFieldMBA && 'currentValue' in pendingFieldMBA) {
        if (pendingFieldMBA.previousValue !== pendingFieldMBA.currentValue) {
          return "text-warning"; // Yellow for MBA changes
        }
      }
    } else if (pendingFieldMBA) {
      return "text-warning";
    }
  }
  
  return "";
};

  return (
    <div className="">
      {uploadLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Uploading...</span>
              </div>
              <div className="fw-bold">Uploading, please wait...</div>
            </div>
          </div>
        )}
      {!(roleIdentifier==="SPO") && <div className="d-flex justify-content-between align-items-center w-100">
        <p className=" m-0" style={{ fontSize: "1.25rem" }}>
          Preview of registration form submitted by Sponsor
        </p>
        {isDisabled ?(<button
          onClick={editHandler}
          className="btn btn-outline-secondary my-4 px-4"
        >
          <i className="feather feather-edit me-2"></i>
          {isDisabled ? "Edit" : "Lock"}
        </button>):
        (<div className="my-4 px-4">Auto Saved</div>) }
      </div>}

      <div className="d-flex bg-white p-5 rounded flex-column text-nightblue justify-content-center">
        <div className="text-center mb-4">
          <h3>FORM - J</h3>
          <h3>[SEE RULE 119(1)]</h3>
          <h3>APPLICATION FOR REGISTRATION AS CONTRACT FARMING</h3>
          <h3>SPONSOR</h3>
        </div>

        <div className="mb-4">
          <p style={{ fontSize: "1.25rem" }} className="text-black">
            To,
          </p>
          <h3 style={{ fontSize: "1.25rem" }} className="text-black mb-3">
            Managing Director
          </h3>
          <h3 style={{ fontSize: "1.25rem" }} className="text-black mb-3">
            Gujarat State Agriculture Marketing Board
          </h3>
          <h3 style={{ fontSize: "1.25rem" }} className="text-black">
            Gandhi Nagar
          </h3>
        </div>

        <div>
          <p style={{ fontSize: "1.25rem" }} className="text-black">
            Sir,
          </p>
          <p style={{ fontSize: "1.25rem" }} className="text-black">
            I/We
            <input
                className={`text-center mx-1 border-0 border-bottom border-secondary mb-4 ${getFieldColorClass("Sponsor_Name", "name")}`}              style={{
                width: `${adjustInputWidth(resubmit?.Sponsor_Name || formData?.name || "")}px`,  // ✅ FIXED
                minWidth: "200px",
                maxWidth:"100%"
              }}
              value={resubmit?.Sponsor_Name ?? formData?.name}
              onChange={(e) => handleInputChange("Sponsor_Name", e.target.value)}
              placeholder="Name"
              disabled={isDisabled}
            />
            (name)
            <input
              className={`text-center mx-1 border-0 border-bottom border-secondary mb-4 ${getFieldColorClass("Sponsor_Address", "address")}`}
              style={{
                width: `${adjustInputWidth(resubmit?.Sponsor_Address || formData?.address || "")}px`,  // ✅ FIXED
                minWidth: "200px",
                maxWidth:"100%"
              }}
                value={resubmit?.Sponsor_Address ?? formData?.address}
              onChange={(e) => handleInputChange("Sponsor_Address", e.target.value)}
              placeholder="Address"
              disabled={isDisabled}
            />
            (address)
            <input
              type="number"
              className={`text-center mx-1 border-0 border-bottom border-secondary mb-4 ${getFieldColorClass("Sponsor_Phone", "phone")}`}
             style={{
                width: `${adjustInputWidth(resubmit?.Sponsor_Phone || formData?.phone || "")}px`,  // ✅ FIXED
                minWidth: "200px",
                maxWidth:"100%"
              }}
              min={0}
              value={resubmit?.Sponsor_Phone ?? formData?.phone}
              onChange={(e) => {
                let value = e.target.value;

                // ✅ Allow only up to 10 digits
                if (value.length > 10) {
                  value = value.slice(0, 10);
                }

                if (value === "" || Number(value) >= 0) {
                  handleInputChange("Sponsor_Phone", value);
                }
              }}
              placeholder="Phone No."
              disabled={isDisabled}
            />
            (phone No.) am/are making an application for a registration as
            Contract Farming Sponsor for the period from
            <input
              type="date"
              value={resubmit?.Sponsor_Reg_From || formData.fromDate || ""}  // ✅ CORRECT
              style={{ width: "135px" }}
              onChange={(e) => handleDateChange("Sponsor_Reg_From", e.target.value)}
              className={`text-center border-0 text-center border-bottom border-2 border-secondary mb-3 rounded-0 mx-2 ${getFieldColorClass("Sponsor_Reg_From", "fromDate")}`}
              disabled={isDisabled}
            />
            to
            <input
              type="date"
              value={resubmit?.Sponsor_Reg_To || formData.toDate || ""}
              style={{ width: "135px" }}
              onChange={(e) => handleDateChange("Sponsor_Reg_To", e.target.value)}
              className={`text-center border-0 text-center border-bottom border-2 border-secondary mb-3 rounded-0 mx-2 ${getFieldColorClass("Sponsor_Reg_To", "toDate")}`}
              disabled={isDisabled}
            />
            i.e
            <input
              type="number"
              value={resubmit?.Sponsor_Reg_Year || formData.years || ""}  // ✅ CORRECT
              placeholder="Years"
              style={{ width: "100px" }}
              disabled
              className="text-center mx-1 text-center border-0 border-bottom border-secondary mb-4"
            />
            years. I/We want the registration for
            <div style={{ display: "inline-block", minWidth: "200px" }}>
              <Select
                isMulti
                options={districtOptions}
                value={selectedDistricts}
                onChange={handleDistrictChange}
                placeholder="Select District(s)"
                className="mx-2 border-0"
                classNamePrefix="react-select"
                isDisabled={true}
              />
            </div>
            district(s)/whole state and
            <div style={{ display: "inline-block", minWidth: "200px" }}>
              <Select
                isMulti
                options={apmcData}
                value={selectedAPMCs}
                onChange={handleAPMCChange}
                placeholder="Select APMC"
                className="mx-2 border-0"
                isDisabled={true}
              />
            </div>
            APMC.
          </p>

          {selectedAPMCs.length > 0 && (
            <table
              className="table table-bordered rounded my-4"
              style={{
                tableLayout: "fixed",
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "30%", fontSize: "1.25rem" }}>APMC</th>
                  <th style={{ width: "20%" }}>Fruits & Vegetables</th>
                  <th style={{ width: "50%" }}>Others</th>
                </tr>
              </thead>
              <tbody>
                {selectedAPMCs.map((apmc) => {
                  const hasFruits = fruitsSelection[apmc.value] || false;
                  const hasOthers =
                    otherInputs[apmc.value] !== null &&
                    otherInputs[apmc.value] !== undefined;

                  return (
                    <tr key={apmc.value}>
                      <td style={{ fontSize: "1.25rem" }}>{apmc.label}</td>
                      <td>
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="checkbox"
                            checked={hasFruits}
                            style={{ transform: "scale(1.5)" }}
                            disabled={true}
                          />
                        </div>
                      </td>
                      <td style={{ minHeight: "60px", verticalAlign: "middle" }}>
                        <input
                          type="checkbox"
                          checked={hasOthers}
                          style={{ transform: "scale(1.5)" }}
                          className="me-4"
                          disabled={true}
                        />
                        {hasOthers && (
                          <Select
                            isMulti
                            options={spicesOptions}
                            value={otherInputs[apmc.value] || []}
                            placeholder="Details"
                            className="border-0 border-bottom border-secondary w-75 d-inline-block"
                            isDisabled={true}
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          {showFeeSummary && (
            <div
              style={{ fontSize: "1.25rem", color: "black" }}
              className="mb-3 border rounded-3 p-3 bg-gray"
            >
              <h2>Fee Summary</h2>
              <div className="border my-3" style={{ height: "1px" }}></div>

              {anyFruitsSelected && (
                <div className="d-flex gap-3 align-items-center justify-content-between mb-2">
                  <p className="m-0">Fruits or Vegetables</p>
                  <p>₹ 500</p>
                </div>
              )}

              {selectedOthersCount > 0 && (
                <div className="d-flex gap-3 align-items-center justify-content-between mb-2">
                  <p className="m-0">Crops Fee (per APMC)</p>
                  <p>
                    ₹ 500 x {selectedOthersCount} = ₹ {othersFee}
                  </p>
                </div>
              )}

              <div className="border my-3" style={{ height: "1px" }}></div>

              <div className="d-flex w-100 justify-content-between">
                <h3>Total Fee</h3>
                <h3>₹ {totalFee}</h3>
              </div>
            </div>
          )}

          <div className="border rounded">
            <p style={{ fontSize: "1.25rem" }} className="text-black p-3">
              Along with this application I am enclosing the following documents:
            </p>

            {/* Document 1 */}
            <div
              className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3"
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">(1) Solvency certificate</span>
              <div className="d-flex flex-column w-25 ms-3">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#contract_farming_modal"
                  className="btn btn-outline-info align-items-center w-100"
                  data-doc-id={resubmit?.solvencyCertificate?.data?.[0]?.docId || formData?.solvencyCertificate?.docId}
                >
                  <i className="ti ti-eye"></i> View Document
                </Link>
                {!isDisabled && (
                  <input
                    type="file"
                    name="solvencyCertificate"
                    onChange={(e) => handleFileChange(e, "solvencyCertificate")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    className="form-control w-100 mt-2"
                    style={{ fontSize: "0.8rem" }}
                  />
                )}
                {newlyUploaded.solvencyCertificate && (
                  <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.solvencyCertificate}</p>
                )}
              </div>
            </div>

            {/* Document 2 */}
            <div
              className="d-flex bg-white p-2 align-items-center justify-content-between mb-3"
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">(2) Bank Guarantee</span>
              <div className="d-flex flex-column w-25 ms-3">
                {(resubmit?.bankGuarantee?.data?.[0]?.docId || formData?.bankGuarantee?.docId) ? (
                  <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#contract_farming_modal"
                  className="btn btn-outline-info align-items-center w-100"
                  data-doc-id={resubmit?.bankGuarantee?.data?.[0]?.docId || formData?.bankGuarantee?.docId}
                >
                  <i className="ti ti-eye"></i> View Document
                </Link>
                ): (<h5 className="text-center">No Document Available</h5>)}
                
                {!isDisabled && (
                  <input
                    type="file"
                    name="bankGuarantee"
                    onChange={(e) => handleFileChange(e, "bankGuarantee")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    className="form-control w-100 mt-2"
                    style={{ fontSize: "0.8rem" }}
                  />
                )}
                {newlyUploaded.bankGuarantee && (
                  <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.bankGuarantee}</p>
                )}
              </div>
            </div>

            {/* Document 3 */}
            {/* Document 3 */}
<div
  className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3"
  style={{ fontSize: "1.25rem", color: "black" }}
>
  <span className="w-50">
    (3) Details of Registration Documents of
    <div style={{ display: "inline-block", minWidth: "200px" }} className="ms-2">
      <Select
        options={organizationTypeOptions}
        value={organizationTypeOptions.find(opt => opt.value === organizationType)}
        placeholder="Organization Type"
        className="border-0 text-black"
        isDisabled={true}
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: "#ffffffff",
            color: "black",
          }),
        }}
      />
    </div>
    and names and addresses of directors and partners, etc.
  </span>
  <div className="d-flex flex-column w-25 ms-3">
    <Link
      to="#"
      data-bs-toggle="modal"
      data-bs-target="#contract_farming_modal"
      className="btn btn-outline-info align-items-center w-100"
      data-doc-id={resubmit?.firmNgoCoopCoopDetails?.data?.[0]?.docId || formData?.firmNgoCoopCoopDetails?.docId}
    >
      <i className="ti ti-eye"></i> View Document
    </Link>
    {!isDisabled && (
      <input
        type="file"
        onChange={(e) => handleFileChange(e, "firmNgoCoopCoopDetails")}
        accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
        name="firmNgoCoopCoopDetails"
        className="form-control mt-2"
        style={{ fontSize: "0.8rem" }}
      />
    )}
    {newlyUploaded.firmNgoCoopCoopDetails && (
      <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.firmNgoCoopCoopDetails}</p>
    )}
  </div>
</div>
            {/* Document 4 */}
            <div
              className="d-flex bg-white p-2 align-items-center justify-content-between mb-3"
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">
                (4) Details of agricultural produce coming under the contract.
              </span>
              <div className="w-25 ps-4 me-2">
                <Select
                  isMulti
                  options={ItemsSponsor.options}
                  value={selectedIngredients}
                  onChange={handleIngredientsChange}
                  placeholder="Select Items"
                  className="mx-2 w-100 border-0"
                  isDisabled={true}
                />
              </div>
            </div>

            {/* Document 5 */}
            <div
              className="d-flex bg-gray p-2 align-items-center justify-content-between"
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">
                (5) Copy of challan under which fee of rupees five hundred per
                year per district has been paid in Government Treasury.
              </span>
              <div className="d-flex flex-column w-25 ms-3">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#contract_farming_modal"
                  className="btn btn-outline-info align-items-center w-100"
                  data-doc-id={resubmit?.challanCopy?.data?.[0]?.docId || formData?.challanCopy?.docId}
                >
                  <i className="ti ti-eye"></i> View Document
                </Link>
                {!isDisabled && (
                  <input
                    type="file"
                    name="challanCopy"
                    onChange={(e) => handleFileChange(e, "challanCopy")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    className="form-control w-100 mt-2"
                    style={{ fontSize: "0.8rem" }}
                  />
                )}
                {newlyUploaded.challanCopy && (
                  <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.challanCopy}</p>
                )}
              </div>
            </div>

            {/* Document 6 */}
            <div
              className="d-flex bg-white p-2 align-items-center justify-content-between mb-3"
              style={{ fontSize: "1.25rem", color: "black" }}
            >
              <span className="w-75">
                (6) Proof of manufacturing, processing, export-import licence.
              </span>
              <div className="d-flex flex-column w-25 ms-3">
                  <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#contract_farming_modal"
                  className="btn btn-outline-info align-items-center w-100"
                  data-doc-id={resubmit?.licenseProof?.data?.[0]?.docId || formData?.licenseProof?.docId}
                >
                  <i className="ti ti-eye"></i> View Document
                </Link>
                  
                {!isDisabled && (
                  <input
                    type="file"
                    name="licenseProof"
                    onChange={(e) => handleFileChange(e, "licenseProof")}
                    accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    className="form-control mt-2"
                    style={{ fontSize: "0.8rem" }}
                  />
                )}
                {newlyUploaded.licenseProof && (
                  <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.licenseProof}</p>
                )}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-5 align-items-end flex-column">
            {/* <div className="d-flex flex-column w-25 mt-5">
               <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#contract_farming_modal"
                  className="btn btn-outline-info align-items-center w-100"
                  data-doc-id={resubmit?.e_Hastakshar?.data?.[0]?.docId || formData?.e_Hastakshar?.docId}
                >
                  <i className="ti ti-eye"></i> View Document
                </Link>
              {!isDisabled && (
                <input
                  type="file"
                  name="e_Hastakshar"
                  onChange={(e) => handleFileChange(e, "e_Hastakshar")}
                  accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                  className="form-control mt-2"
                  style={{ fontSize: "0.8rem" }}
                />
              )}
              {newlyUploaded.e_Hastakshar && (
                <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.e_Hastakshar}</p>
              )}
            </div> */}
            <p
              style={{ fontSize: "1.25rem" }}
              className="text-black py-3 position-relative left-0"
            >
              Signature of Applicant.
            </p>
          </div>
        </div>
      </div>
       {roleIdentifier==="MBA" && (
        <div className="d-flex justify-content-end px-5 mb-5">
            <Link
              className="btn btn-info mt-4"
              style={{cursor:"pointer"}}
              data-bs-toggle="modal"
              to="#exampleModalToggle"
              role="button"
            >
              Forward to MBMD
            </Link>
          </div>
       )}
       {roleIdentifier==="SPO" && valCalledIn !== "registrationStatus" && (
        <div className="d-flex justify-content-end px-5 mb-5">
        <button 
          className="btn btn-info mt-4"
          onClick={handleForward}
          >
            Forward to MBA
        </button>
        </div>
       )}
          <div className="col-xl-4">
            <div className="card-body">
              {/* Modal */}
              <div
                className="modal fade"
                id="exampleModalToggle"
                aria-hidden="true"
                aria-labelledby="exampleModalToggleLabel"
                tabIndex={-1}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title" id="exampleModalToggleLabel">
                        Forward Application
                      </h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      <p className="mb-3">
                        Are you sure you want to forward this application to
                        Managing Director for approval?
                      </p>
                      <textarea
                        className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                        style={{ fontSize: "1rem" }}
                        rows={3}
                        name="commentRemark"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Enter your remarks here."
                        required
                      />
                      {comment.trim() === '' && (
                        <small className="text-danger">* Remarks are required</small>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-secondary me-3"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        Cancel
                      </button>
                      {/* <button
                        className="btn btn-info"
                        data-bs-target="#exampleModalToggle2"
                        data-bs-toggle="modal"
                        data-bs-dismiss="modal"
                        onClick={handleForward}
                      >
                        Yes Forward
                      </button> */}
                       <button 
                        className="btn btn-info"
                        onClick={handleForward}
                        data-bs-dismiss="modal"
                        >
                          Yes Forward
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      <DocView key={documentUpdateTrigger} />
    </div>
  );
};

export default MBAFormJ;